module.exports = __webpack_public_path__ + "images/blueEyeOpened-284a9c61e9650e4209be04a1126be38a.svg";